export default function EFLocation(props: any) {
    return (
        <svg
            width="20px"
            height="20px"
            viewBox="0 0 20 20"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            {...props}
        >
            <g id="页面-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="Where-to-Buy_02" transform="translate(-176.000000, -484.000000)">
                    <g id="编组-11" transform="translate(160.000000, 430.000000)">
                        <g id="编组-2" transform="translate(16.000000, 54.000000)">
                            <rect id="矩形" x="0" y="0" width="20" height="20"></rect>
                            <path
                                d="M10,6.83333326 C10.5792952,6.83333326 11.1035181,7.06608463 11.4830684,7.44168128 C11.8645235,7.81916294 12.1,8.34077614 12.1,8.9166666 C12.1,9.49255707 11.8645235,10.0141703 11.4830684,10.3916519 C11.1035181,10.7672486 10.5792952,10.9999999 10,10.9999999 C9.4207048,10.9999999 8.89648193,10.7672486 8.51693164,10.3916519 C8.13547649,10.0141703 7.9,9.49255707 7.9,8.9166666 C7.9,8.34077614 8.13547649,7.81916294 8.51693164,7.44168128 C8.89648193,7.06608463 9.4207048,6.83333326 10,6.83333326 Z"
                                id="Path"
                                stroke="#757575"
                            ></path>
                            <path
                                d="M9.91666667,2.5 C11.7363229,2.5 13.3843305,3.21513959 14.5770186,4.37328729 C15.7643102,5.52619481 16.5,7.11854877 16.5,8.87819928 C16.5,11.1396003 15.1366262,13.4910557 12.9003824,15.7831756 C12.075969,16.6281883 11.1899852,17.4022885 10.3043845,18.0870664 C8.64334811,17.4022885 7.75736435,16.6281883 6.93295096,15.7831756 C4.69670713,13.4910557 3.33333333,11.1396003 3.33333333,8.87819928 C3.33333333,7.11854879 4.06902313,5.52619483 5.25631473,4.37328731 C6.4490028,3.2151396 8.09701046,2.5 9.91666667,2.5 L9.91666667,2.5 Z"
                                id="Path"
                                stroke="#757575"
                            ></path>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
}
